import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';
import { ShareIcon } from '@change/ds-icons/ShareIcon';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { usePhoto } from '#src/app/pages/petitionDetails/shared/hooks';

import { usePetitionHeadingMobile } from './hooks/usePetitionHeadingMobile';

export const NativeShareMobile: React.FC<EmptyProps> = () => {
	const { translate } = useI18n();
	const photo = usePhoto();
	const { data } = usePetitionHeadingMobile();
	const ShareAction = data.shareAction?.ShareAction;

	return (
		<div
			// The offset is the spiking petition banner's height, set while that banner is shown: both stick to the
			// top of the viewport, and the banner would otherwise cover this button. See useBannerHeightCssVariable.
			className="sticky top-[var(--spiking-petition-banner-height,0px)] z-29 flex h-0 justify-end"
			data-testid="native-share-mobile"
			data-qa="native-share-mobile"
		>
			{photo && ShareAction && (
				<div className="block md:hidden">
					<ShareAction>
						<Button
							aria-label={translate('corgi.petition_gamma.share.mobile_native_share')}
							iconOnly
							leadingIcon={<ShareIcon className="text-icon-strong-fixed" />}
							variant="tertiary"
							data-qa="native-share-button"
							data-testid="native-share-button"
							// eslint-disable-next-line @change-ds/ds-no-raw-color-classname -- white button floating over the photo in both modes, paired with icon-strong-fixed (no fixed fill token)
							className="mt-4 mr-4 h-12 min-h-12 w-12 min-w-12 rounded-full border-0 bg-white p-3 shadow-[0px_2px_12px_0px_rgba(58,41,62,0.25)]"
						>
							<Translate value="corgi.petition_gamma.share.mobile_native_share" />
						</Button>
					</ShareAction>
				</div>
			)}
		</div>
	);
};
